function Attach({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions / 2 || '12'} height=${dimensions || '24'} viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 5V16.5C9.5 18.71 7.71 20.5 5.5 20.5C3.29 20.5 1.5 18.71 1.5 16.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V16.5C0 19.54 2.46 22 5.5 22C8.54 22 11 19.54 11 16.5V5H9.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Attach;
